// extracted by mini-css-extract-plugin
export var label = "_a3-1";
export var reminder = "_a3-0";